import { FunctionComponent } from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { Button } from '@nps.today/component-library';
import { ChildTenant } from '../../../@types/organization';
import { RootState, useSelector } from 'redux/store';
import { useTranslator } from 'translation/useTranslator';

interface ChildTenantAccessCellProps {
  childTenant: ChildTenant;
  onManageAccess: (childTenant: ChildTenant) => void;
}

const ChildTenantAccessCell: FunctionComponent<ChildTenantAccessCellProps> = ({
  childTenant,
  onManageAccess
}) => {
  const translator = useTranslator();
  const { organizations: tenantsYouCanAccess, currentTenant } = useSelector(
    (state: RootState) => state.organization
  );

  const isCurrentTenant = currentTenant?.id === childTenant.id;
  if (isCurrentTenant) {
    return (
      <Typography variant="body2" color="text.disabled" noWrap>
        {translator.managedUnderUsers()}
      </Typography>
    );
  }

  const youHaveAccess = tenantsYouCanAccess.some((org) => org.organizationId === childTenant.id);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button
        dataTestId={`manage-child-tenant-access-${childTenant.id}`}
        size="small"
        variant="text"
        onClick={(event: any) => {
          event.stopPropagation();
          onManageAccess(childTenant);
        }}
      >
        {translator.manageAccess()}
      </Button>
      {youHaveAccess && <Chip size="small" label={translator.youHaveAccess()} />}
    </Stack>
  );
};

export default ChildTenantAccessCell;
